export const DashboardStrings = {
  en: {
    description: 'Are you sure you want Logout',
    logout: 'Logout',
    dashboard: 'Dashboard'
  }
}
